import { Hidden }      from "@material-ui/core";
import ja              from "date-fns/locale/ja";
import React, { FC }   from "react";
import ReactDatePicker from "react-datepicker";
import { Button }      from "semantic-ui-react";
import Date            from "../../../domain/fundamentals/date/Date";

interface Props {
  date: Date;
  onChange: (date: Date) => void;
}

const DateSelector: FC<Props> = (props: Props) => {
  return (
    <>
      <Hidden smDown={ true }>
        <ReactDatePicker
          locale={ ja }
          onChange={ (date) => date ? props.onChange(Date.ofText(date.toDateString())) : new Date() }
          customInput={
            <Button>{ props.date.asText() }</Button>
          }
        />
      </Hidden>
      <Hidden mdUp={ true }>
        <ReactDatePicker
          locale={ ja }
          onChange={ (date) => date ? props.onChange(Date.ofText(date.toDateString())) : new Date() }
          withPortal={ true }
          customInput={
            <Button>{ props.date.asText() }</Button>
          }
        />
      </Hidden>
    </>
  );
};

export default DateSelector;